import * as React from 'react';
export const caissedepargneSvg = React.forwardRef(
  function caissedepargneSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E20025',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M10.744 14H8.52l.7-1h2.454C16.077 8.67 23.578 6.14 24 6v1.41c-.092 0-6.195 2.096-10.332 5.59h2.592l-.7 1h-2.979c-.32.324-.62.657-.895 1h3.164l-.7 1h-3.172a7.19 7.19 0 0 0-.87 2h2.632l-.7 1H9.945a5.58 5.58 0 0 0-.015.41 6.76 6.76 0 0 0 1.63 4.4l7.26-12.15 1.21.72-8.2 13.69-.64-.63a8.3 8.3 0 0 1-2.67-6.07c0-.124.003-.247.01-.37H5l.7-1h2.961c.143-.693.391-1.36.723-2H7.11l.71-1h2.162c.232-.342.487-.675.762-1ZM23 26h-9l1-1h9l-1 1Zm-1-3h-5l1-1h5l-1 1Zm.17-4.45-.78-1.17 1.5-1.01-.98-1.37 1.14-.82 1.84 2.56-2.72 1.81ZM20.5 16.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z',
        fill: '#fff',
      }),
    );
  },
);
caissedepargneSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var caissedepargne = {
  category: 'brand',
  colorable: false,
  name: 'caissedepargne',
  svg: caissedepargneSvg,
};
